// import React, { useEffect, useState } from "react";
// import "../css/Theme.css";
// import { useDispatch, useSelector } from "react-redux";
// import { onSnapshot } from "firebase/firestore";
// import {
//   collection,
//   addDoc,
//   Timestamp,
//   getDocs,
//   doc,
//   updateDoc,
// } from "firebase/firestore";
// import { db } from "../firebase";
// import { setTheme } from "../slices/ThemeSlice";

// const Theme = () => {
//   const currentTheme = useSelector((state) => state.theme.current);
//   const dispatch = useDispatch();

//   const [color, setColor] = useState("");

//   const updateStatus = async (id, theme) => {
//     try {
//       dispatch(setTheme(theme)); // update redux instantly

//       const docRef = doc(db, "Theme", id);
//       await updateDoc(docRef, {
//         theme: theme, // ✅ correct value
//       });
//     } catch (error) {
//       alert("Operation not allowed for viewers");
//     }
//   };

//   useEffect(() => {
//     const unsub = onSnapshot(collection(db, "Theme"), (snapshot) => {
//       snapshot.forEach((doc) => {
//         dispatch(setTheme(doc.data().theme));
//       });
//     });

//     return () => unsub();
//   }, []);

//   return (
//     <div className="theme-container">
//       <h1>Theme</h1>

//       <button
//         className={`black-theme ${currentTheme === "#000000" ? "active" : ""}`}
//         // onClick={() => updateStatus("ECwCWzRMsW35CCes4XoK", "#000000")}
//         onClick={() => updateStatus("ECwCWzRMsW35CCes4XoK", "#162f06")}
//       >
//         Black
//       </button>

//       <button
//         className={`red-theme ${currentTheme === "#381317" ? "active" : ""}`}
//         // onClick={() => updateStatus("ECwCWzRMsW35CCes4XoK", "#381317")}
//         onClick={() => updateStatus("ECwCWzRMsW35CCes4XoK", "#162f06")}
//       >
//         Red
//       </button>

//       <button
//         className={`green-theme ${currentTheme === "#162f06" ? "active" : ""}`}
//         onClick={() => updateStatus("ECwCWzRMsW35CCes4XoK", "#162f06")}
//       >
//         Green
//       </button>
//     </div>
//   );
// };

// export default Theme;


import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../slices/ThemeSlice";
import "../css/Theme.css";

const THEMES = [
  {
    id: "forest",
    name: "Forest Green",
    desc: "Classic AQWF dark forest green",
    primary: "#162f06",
    accent: "#f7f2b8",
    preview: ["#162f06", "#2a5410", "#f7f2b8"],
  },
  {
    id: "midnight",
    name: "Midnight Black",
    desc: "Sleek and professional dark",
    primary: "#000000",
    accent: "#fdbe33",
    preview: ["#000000", "#1a1a1a", "#fdbe33"],
  },
  {
    id: "crimson",
    name: "Crimson",
    desc: "Rich deep red",
    primary: "#381317",
    accent: "#f7d6b8",
    preview: ["#381317", "#5a1e24", "#f7d6b8"],
  },
  {
    id: "royalblue",
    name: "Royal Blue",
    desc: "Bold and trustworthy navy",
    primary: "#0d2137",
    accent: "#b8d4f7",
    preview: ["#0d2137", "#1a3a5c", "#b8d4f7"],
  },
  {
    id: "emerald",
    name: "Emerald",
    desc: "Vibrant emerald green",
    primary: "#065f46",
    accent: "#d1fae5",
    preview: ["#065f46", "#059669", "#d1fae5"],
  },
  {
    id: "plum",
    name: "Plum Purple",
    desc: "Elegant deep purple",
    primary: "#3b0764",
    accent: "#e9d5ff",
    preview: ["#3b0764", "#6d28d9", "#e9d5ff"],
  },
  {
    id: "slate",
    name: "Slate Grey",
    desc: "Modern and neutral",
    primary: "#1e293b",
    accent: "#e2e8f0",
    preview: ["#1e293b", "#334155", "#e2e8f0"],
  },
  {
    id: "copper",
    name: "Copper Bronze",
    desc: "Warm earthy copper tones",
    primary: "#5c2d0e",
    accent: "#fde9cf",
    preview: ["#5c2d0e", "#92400e", "#fde9cf"],
  },
  {
    id: "teal",
    name: "Deep Teal",
    desc: "Calm ocean teal",
    primary: "#0f3d3e",
    accent: "#ccfbf1",
    preview: ["#0f3d3e", "#0d6b6e", "#ccfbf1"],
  },
  {
    id: "charcoal",
    name: "Charcoal & Gold",
    desc: "Classic premium charcoal with gold",
    primary: "#1c1c1e",
    accent: "#fbbf24",
    preview: ["#1c1c1e", "#3a3a3c", "#fbbf24"],
  },
];

export default function Theme() {
  const dispatch     = useDispatch();
  const currentTheme = useSelector((s) => s.theme.current);
  const [flash, setFlash] = useState(null);

  const applyTheme = (color) => {
    dispatch(setTheme(color));   // ← correct action, also saves to localStorage in slice
    setFlash(color);
    setTimeout(() => setFlash(null), 1800);
  };

  const active = THEMES.find((t) => t.primary === currentTheme);

  return (
    <div className="th-root">
      {/* Header */}
      <div className="th-header">
        <h2 className="th-title">🎨 Theme Settings</h2>
        <p className="th-sub">
          Choose a colour theme for the dashboard and navbar. Theme is saved and
          persists across page reloads.
          {active && <> &nbsp;·&nbsp; <strong>Current: {active.name}</strong></>}
        </p>
      </div>

      {/* Active preview */}
      {active && (
        <div className="th-active-banner" style={{ background: active.primary }}>
          <div className="th-active-swatches">
            {active.preview.map((c, i) => (
              <span key={i} className="th-active-swatch" style={{ background: c }} />
            ))}
          </div>
          <div className="th-active-info">
            <span className="th-active-name">{active.name}</span>
            <span className="th-active-desc">{active.desc}</span>
          </div>
          <span className="th-active-pill">✓ Active</span>
        </div>
      )}

      {/* Grid */}
      <div className="th-grid">
        {THEMES.map((theme) => {
          const isCurrent = currentTheme === theme.primary;
          const isFlash   = flash === theme.primary;

          return (
            <div
              key={theme.id}
              className={`th-card ${isCurrent ? "th-card-active" : ""}`}
              style={{ "--primary": theme.primary, "--accent": theme.accent }}
            >
              <div className="th-palette">
                {theme.preview.map((c, i) => (
                  <div key={i} className="th-swatch" style={{ background: c, flex: i === 0 ? 2 : 1 }} />
                ))}
              </div>

              <div className="th-card-body">
                <div className="th-card-info">
                  <span className="th-card-name">{theme.name}</span>
                  <span className="th-card-desc">{theme.desc}</span>
                  <div className="th-hex-row">
                    {theme.preview.map((c, i) => (
                      <span key={i} className="th-hex-chip">
                        <span className="th-hex-dot" style={{ background: c }} />
                        {c}
                      </span>
                    ))}
                  </div>
                </div>

                <button
                  className={`th-apply-btn ${isCurrent ? "th-apply-active" : ""}`}
                  style={{
                    background:   isCurrent ? theme.primary : "transparent",
                    color:        isCurrent ? theme.accent  : theme.primary,
                    borderColor:  theme.primary,
                  }}
                  onClick={() => !isCurrent && applyTheme(theme.primary)}
                >
                  {isFlash ? "✓ Applied!" : isCurrent ? "✓ Active" : "Apply Theme"}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="th-tip-box">
        <span className="th-tip-icon">💡</span>
        <p className="th-tip-text">
          Theme changes apply instantly to the sidebar and navbar and are saved to
          <code> localStorage</code> — they persist across page reloads automatically.
        </p>
      </div>
    </div>
  );
}